import { createSlice } from '@reduxjs/toolkit';

const initialState = { ...window._THULEDATA._Cart };

export const CartPageDataSlice = createSlice({
  name: 'cartPageData',
  initialState,
  reducers: {},
});

export default CartPageDataSlice.reducer;
